import { gql, useLazyQuery, useMutation } from "@apollo/client";
import React, { useState } from "react";
// import { CheckboxComponent } from "../../../../../components/CheckboxComponent";
import { Toast } from "../../../../../hooks/toast";
import { Grid, Modal, Thumbnail } from "@shopify/polaris";

interface Props {
  item: any;
  onClickCancel: () => void;
}

const CALCULATE_PRODUCT_PRICE = gql`
  query CalculateProductPrice($sellerPrice: Decimal, $salePrice: Decimal) {
    calculateProductPrice(sellerPrice: $sellerPrice, salePrice: $salePrice) {
      salePrice
      sellerPrice
    }
  }
`;

const SET_TYPE_SUPPLIER_APPROVED = gql`
  mutation setTypeSupplierProductApproved($id: Int!, $status: SupplierProductApproved, $data: OfferInput) {
    setTypeSupplierProductApproved(id: $id, status: $status, data: $data)
  }
`;

export function OfferEditPanel(props: Props) {
  const [priceInput, setPriceInput] = useState(
    typeof props.item.content.sellerPrice === "string"
      ? Number(props.item.content!.sellerPrice!.replace("$", "").trim())
      : Number(props.item.content!.sellerPrice!) || 0,
  );
  const [appPriceInput, setAppPriceInput] = useState(
    typeof props.item.content.saleprice === "string"
      ? Number(props.item.content!.saleprice!.replace("$", "").trim())
      : Number(props.item.content!.saleprice!) || 0,
  );
  const [percent, setPercent] = useState<any>(Number(props.item.content!.discount!).toFixed(2));
  const [usd, setUSD] = useState<any>(
    (Number(props.item.content!.saleprice!) * (Number(props.item.content!.discount!) / 100)).toFixed(2),
  );
  const [calculatePrice] = useLazyQuery(CALCULATE_PRODUCT_PRICE);
  const [setTypeSupplierProductApproved] = useMutation(SET_TYPE_SUPPLIER_APPROVED, {
    refetchQueries: ["supplierProductRequestList", "productListV2", "supplierRestockingSku"],
    onCompleted: (res) => {
      if (res.setTypeSupplierProductApproved) {
        props.onClickCancel();
        Toast.onShow("Update offer was success", "success", "right");
      }
    },
  });

  const onSubmit = (e: any) => {
    e.preventDefault();

    const data = {
      price: Number(e.target.price.value),
      discount: Number(percent),
    };

    setTypeSupplierProductApproved({
      variables: {
        id: Number(props.item.id),
        status: "DISCOUNT_OFFER",
        data,
      },
    });
  };

  const onChangePercent = (e: any) => {
    if (e.target.value !== null || e.target.value !== undefined) {
      if (Number(e.target.value) > 100 || Number(e.target.value) < 0) return;
      setPercent(e.target.value);
      const usd = Number(appPriceInput) * (Number(e.target.value) / 100);
      setTimeout(() => {
        setUSD(usd);
      }, 500);
    }
  };

  const onChangeUSD = (e: any) => {
    if (e.target.value !== null || e.target.value !== undefined) {
      if (Number(e.target.value) > Number(appPriceInput) || Number(e.target.value) < 0) {
        e.target.value = Number(appPriceInput);
      }
      setUSD(e.target.value);
      const percent = (Number(e.target.value) * 100) / Number(appPriceInput);
      setTimeout(() => {
        setPercent(percent);
      }, 500);
    }
  };

  const x = props.item;

  return (
    <Modal open={props.item !== null} onClose={props.onClickCancel} title="Edit Price">
      <Modal.Section>
        <Grid>
          <Grid.Cell columnSpan={{ xs: 6, sm: 3, md: 3, lg: 6, xl: 6 }}>
            <div style={{ display: "flex" }}>
              <Thumbnail source={x.content!.picture!} alt="" size="large" />
              <div className="ml-2">
                <small>{x.content.supplierCode}</small>
                <br />
                <small>L192: {x.content.code}</small>
                <br />
                <small>Price: ${x.content.price}</small>
                <br />
                <small>Discount: {x.content.discount.toFixed(2)}%</small>
              </div>
            </div>
          </Grid.Cell>
          <Grid.Cell columnSpan={{ xs: 6, sm: 3, md: 3, lg: 6, xl: 6 }}>
            <form onSubmit={(e) => onSubmit(e)}>
              <div className="form-group">
                <label>Seller Offer Price</label>
                <input
                  type="number"
                  placeholder="Enter offer price..."
                  className="form-control"
                  value={priceInput}
                  step={"any"}
                  name="price"
                  onFocus={(e) => {
                    e.target.select();
                  }}
                  onChange={(e) => {
                    setPriceInput(Number(e.target.value));
                    if (Number(e.target.value) > 0) {
                      calculatePrice({
                        variables: { sellerPrice: e.target.value, salePrice: null },
                      }).then((res) => {
                        setAppPriceInput(res.data.calculateProductPrice.salePrice);
                        const discountUSD = (Number(percent) / 100) * Number(res.data.calculateProductPrice.salePrice);
                        setUSD(discountUSD);
                      });
                    }
                  }}
                />
              </div>
              <div className="form-group">
                <label>App Offer Price</label>
                <input
                  type="number"
                  placeholder="Enter offer price..."
                  className="form-control"
                  value={appPriceInput}
                  step={"any"}
                  name="app_price"
                  onFocus={(e) => {
                    e.target.select();
                  }}
                  onChange={(e) => {
                    setAppPriceInput(Number(e.target.value || 0));
                    if (Number(e.target.value) > 0) {
                      calculatePrice({
                        variables: { sellerPrice: null, salePrice: e.target.value },
                      }).then((res) => {
                        setPriceInput(res.data.calculateProductPrice.sellerPrice);
                        setAppPriceInput(res.data.calculateProductPrice.salePrice);
                        const discountUSD = (Number(percent) / 100) * Number(res.data.calculateProductPrice.salePrice);
                        setUSD(discountUSD);
                      });
                    }
                  }}
                />
              </div>
              <label>Discount in percentage[%]</label>
              <div className="form-group">
                <input
                  type="number"
                  placeholder="Enter offer discount..."
                  className="form-control"
                  value={percent}
                  onChange={onChangePercent}
                  step={"any"}
                  name="percent"
                  onFocus={(e) => {
                    e.target.select();
                  }}
                />
              </div>
              <label>Discount in amount[USD]</label>
              <div className="form-group">
                <input
                  type="number"
                  placeholder="Enter offer discount..."
                  className="form-control"
                  value={usd}
                  onChange={onChangeUSD}
                  step={"any"}
                  name="usd"
                  onFocus={(e) => {
                    e.target.select();
                  }}
                />
              </div>
              <div>
                <button className="btn btn-danger mr-2" type="button" onClick={props.onClickCancel}>
                  Cancel
                </button>
                <button className="btn btn-primary" type="submit">
                  Set
                </button>
              </div>
            </form>
          </Grid.Cell>
        </Grid>
      </Modal.Section>
    </Modal>
  );
}
